/**
 * EmptyYearEnd
 *
 * 해당 연도 데이터가 없을 때 표시
 */

import React from 'react';
import { Stack, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

export const EmptyYearEnd = ({ year }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack
      spacing={3}
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: '60vh',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          bgcolor: 'action.hover',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CalendarMonthOutlinedIcon
          sx={{ fontSize: 40, color: 'text.disabled' }}
        />
      </Box>

      <Stack spacing={1}>
        <Typography variant="h5" fontWeight={600}>
          {t('yearEnd.empty.title', { year })}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('yearEnd.empty.description', { year })}
          <br />
          {t('yearEnd.empty.suggestion')}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          onClick={() => navigate('/post-thread')}
          sx={{ borderRadius: 2 }}
        >
          {t('yearEnd.empty.writeThread')}
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate('/dashboard')}
          sx={{ borderRadius: 2 }}
        >
          {t('yearEnd.empty.goToDashboard')}
        </Button>
      </Stack>
    </Stack>
  );
};

export default EmptyYearEnd;
